import { useUiToast } from '~/composables/useUiToast';
import { showAlert } from '~/composables/useConfirmDialog';
import { appT } from '~/composables/useAppI18n';

/**
 * HTTP 200 + result FAIL: 알림 표시 후 true 반환 (호출부에서 return / Promise.reject 처리)
 * HTTP 4xx/5xx는 useApi 토스트
 */
export const handleApiResultFail = (
  response: { result?: string; msg?: string },
  onFail?: (msg: string) => void,
): boolean => {
  if (response?.result === 'FAIL') {
    const msg = response.msg ?? '';
    if (onFail) {
      onFail(msg);
    } else {
      showAlert(appT('common.error'), msg || appT('common.fail'));
    }
    return true;
  }
  return false;
};

/** UiToastNotification에 표시되는 API 알림 (Nuxt UI useToast와 분리) */
export const notifyApiError = (heading: string, detail?: string) => {
  if (!process.client) return;
  const { error } = useUiToast();
  const message = detail ? `${heading}: ${detail}` : heading;
  error(message);
};

export const notifyApiSuccess = (message: string) => {
  if (!process.client) return;
  const { success } = useUiToast();
  success(message);
};
